
  import {Component, Vue, Prop} from "vue-property-decorator";
  import deviceItem from "./deviceItem";
  import DeviceStatusItem from "@/views/components/DeviceStatus/DeviceStatusItem.vue";
  import DeviceStatusItem2 from "@/views/components/DeviceStatus/DeviceStatusItem2.vue";

  @Component({
    name: "deviceStatus",
    components: {DeviceStatusItem2, DeviceStatusItem},
  })
  export default class extends Vue {
    @Prop() readonly deviceItems: deviceItem[];
    @Prop() readonly deviceStateLabelVisible: boolean;
    public isShow = true;

    // private deviceItems: deviceItem[] = []
  }
